import { gql } from '@apollo/client';

const MEDIA_PLAYBACK_FIELDS = gql`
    fragment MediaPlaybackFields on MediaPlayback {
        id
        slug
        title
        blurb
        description
        date
        canAddToReel
        feeds {
            type
            duration
            closedCaptions
            playbacks {
                name
                url
                segments
            }
            image {
                altText
                templateUrl
                cuts {
                    aspectRatio
                    width
                    height
                    src
                }
            }
        }
        keywordsDisplay {
            slug
            displayName
        }
        isInReel @client
        translationId
        playInfo {
            balls
            strikes
            outs
            inning
            inningHalf
            pitchSpeed
            pitchType
            exitVelocity
            hitDistance
            launchAngle
            spinRate
            scoreDifferential
            gamePk
            runners {
                first
                second
                third
            }
            teams {
                away {
                    name
                    shortName
                    triCode
                }
                home {
                    name
                    shortName
                    triCode
                }
                batting {
                    name
                    shortName
                    triCode
                }
                pitching {
                    name
                    shortName
                    triCode
                }
            }
            players {
                pitcher {
                    id
                    name
                    lastName
                    playerHand
                }
                batter {
                    id
                    name
                    lastName
                    playerHand
                }
            }
        }
    }
`;

const MEDIA_PLAYBACK_SHARE = gql`
    fragment MediaPlaybackShare on MediaPlayback {
        slug
        title
        blurb
        description
        feeds {
            type
            image {
                cuts {
                    src
                }
            }
        }
    }
`;

const CORE_SEARCH_FIELD_METADATA = gql`
    fragment CoreSearchFieldMetadata on SearchFieldMetadata {
        id
        category
        description
        defaultOperator
        displayName
        display
        helperText
        name
        type
        supportsDistinctValues
        range {
            min
            max
        }
        unitOfMeasurement {
            value
            spanishValue
        }
    }
`;

export default {
    MEDIA_PLAYBACK_FIELDS,
    MEDIA_PLAYBACK_SHARE,
    CORE_SEARCH_FIELD_METADATA,
};
